import styled from "styled-components";

import { Link } from 'react-router-dom'

export const Gallery = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center;
  padding: 40px;
  margin: 0;
  list-style-type: none;
  background: #d8bdff;
  
  @media (max-width: 1400px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const ProjectWrapper = styled.li`
  position: relative;
  margin: 20px 15px;
`;

export const ProjectOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  @media (min-width: 1000px) {
  background: transparent;
  ${ProjectWrapper}:hover & {
    background: rgba(0, 0, 0, 0.75);
  }
  }
`;

export const ProjectImage = styled.img`
  width: 423px;
  height: 423px;
  overflow: hidden;
  object-fit: cover;

  @media (min-width: 800px) and (max-width: 1000px) {
    width: 350px;
    height: 350px;
  }

  @media (max-width: 800px) {
    width: 250px;
    height: 250px;
  }
`;

export const ArtProjectLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: 0;
  color: white;
  font-family: 'Spectral', 'times', serif;
  text-decoration: none;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;

  @media (min-width: 1000px) {
    color: transparent;
    ${ProjectWrapper}:hover & {
    color: white;
  }
  }
`;

export const TechProjectLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: 0;
  color: white;
  font-family: 'Spectral', 'times', serif;
  text-decoration: none;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;

  @media (min-width: 1000px) {
    color: transparent;
    ${ProjectWrapper}:hover & {
    color: white;
  }
  }
`;